import * as React from "react";
const SvgFiRrMushroomAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mushroom-alt_svg__a)">
      <path
        fill="#062147"
        d="M23.925 9.367C22.665 3.939 17.65 0 12 0 6 0 1.301 4.088.075 9.368a2.9 2.9 0 0 0 .566 2.471A3.06 3.06 0 0 0 3.054 13h4.872C7.343 15.524 7 18.585 7 19.5c0 2.523 2.196 4.5 5 4.5s5-1.977 5-4.5c0-.915-.344-3.976-.926-6.5h4.872c.947 0 1.827-.423 2.413-1.161a2.9 2.9 0 0 0 .566-2.472M11 2.5C11 3.879 9.878 5 8.5 5a2.46 2.46 0 0 1-2.17-1.29 10.35 10.35 0 0 1 4.621-1.65c.026.145.048.29.048.44zm4 17c0 1.425-1.29 2.5-3 2.5s-3-1.075-3-2.5c0-.872.376-4.093.983-6.5h4.033c.607 2.407.983 5.628.983 6.5zm6.792-8.905a1.07 1.07 0 0 1-.847.405h-8.232A1.95 1.95 0 0 0 13 10a2 2 0 1 0-4 0c0 .368.111.705.286 1h-6.23c-.334 0-.643-.147-.847-.405a.9.9 0 0 1-.184-.774C2.46 7.946 3.438 6.29 4.765 4.985A4.44 4.44 0 0 0 8.5 7.001c2.481 0 4.5-2.019 4.5-4.5 0-.154-.035-.302-.05-.453 4.331.406 8.046 3.548 9.027 7.772a.9.9 0 0 1-.185.775M18 7.5A1.5 1.5 0 1 1 15 7.499 1.5 1.5 0 0 1 18 7.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mushroom-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMushroomAlt;
